import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryDto } from '../../../service/dto';
import { HttpCategoryService } from '../../../service/http-category.service';

@Component({
  selector: 'app-category-list',
  standalone: false,
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.scss'
})
export class CategoryListComponent {
	data: CategoryDto[] = [];
	constructor(private httpService: HttpCategoryService, private router: Router){

	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data=result);
	}

	doView(input: CategoryDto){
		this.router.navigate(['/category',input.id,'edit']);
	}
}
